import React from "react";
import { object, array } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import CardImage from "../CardImage";

import "./storyHeroImage.m.css";

const StoryHeroImage = ({ story, imageWidth = [1140], publisherAttributes }) => {
  const langImageCaption = publisherAttributes.lang === "en" ? "en-image-caption" : "";

  return (
    <div styleName="card-image">
      <CardImage
        story={story}
        defaultWidth={760}
        aspectRatio={[1200, 572]}
        imageType="image1200x574"
        widths={imageWidth}
        showStoryTypeIcon={false}
        showAlternateImage={false}
      />

      {story["hero-image-caption"] && (
        <div styleName={`image-caption ${langImageCaption}`}>
          <figcaption className="story-element-image-caption">
            {story["hero-image-caption"]}
            {story["hero-image-attribution"] && <span styleName="en-attribute">{story["hero-image-attribution"]}</span>}
          </figcaption>
        </div>
      )}
    </div>
  );
};

StoryHeroImage.propTypes = {
  story: object.isRequired,
  imageWidth: array,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(StoryHeroImage);
